import { routes } from '@/config/routes';

export function getSafeRedirectTarget(
  candidate: string | null | undefined,
  fallback = routes.dashboard,
) {
  if (!candidate) return fallback;

  try {
    const decoded = decodeURIComponent(candidate);
    if (
      !candidate.startsWith('/') ||
      candidate.startsWith('//') ||
      decoded.startsWith('//') ||
      candidate.includes('\\') ||
      decoded.includes('\\') ||
      Array.from(decoded).some((character) => character.charCodeAt(0) < 32)
    ) {
      return fallback;
    }

    const parsed = new URL(candidate, 'https://emazy.local');
    if (parsed.origin !== 'https://emazy.local') return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}
